import { useMutation } from '@tanstack/react-query';
import type { FC } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { ButtonRow } from '../../../components/global/ButtonRow/ButtonRow.tsx';
import { FlowStepWithContainer } from '../../../components/layout/FlowStepWithContainer.tsx';
import { PasswordForm } from '../../../forms/auth/Password/PasswordForm.tsx';
import { resetPassword } from '../../../services/promoterAuthentication.ts';
import { readResetPasswordState } from './resetPasswordState.ts';

export const Password: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, code } = readResetPasswordState(location.state);

  const { mutate: enterEmail, isPending } = useMutation({
    mutationFn: async ({ password }: { password: string }) => {
      await resetPassword.newPassword({
        password,
        email,
        resetCode: code,
      });
    },
    onSuccess: () => {
      void navigate('../success', { relative: 'path' });
    },
  });

  return (
    <FlowStepWithContainer
      bodyContent={
        <PasswordForm
          buttonSlot={
            <ButtonRow
              primaryButton={{
                type: 'submit',
                text: 'Next',
                isPending,
              }}
            />
          }
          defaultValues={{ password: '' }}
          onSubmit={(data) => enterEmail(data)}
        />
      }
      heading="Set your new password"
      progress={{ currentStep: 3, totalSteps: 3 }}
    />
  );
};
